/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OTPRequestResponse200
 */
export interface OTPRequestResponse200 {
    /**
     * 
     * @type {string}
     * @memberof OTPRequestResponse200
     */
    phone_id: string;
}

/**
 * Check if a given object implements the OTPRequestResponse200 interface.
 */
export function instanceOfOTPRequestResponse200(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "phone_id" in value;

    return isInstance;
}

export function OTPRequestResponse200FromJSON(json: any): OTPRequestResponse200 {
    return OTPRequestResponse200FromJSONTyped(json, false);
}

export function OTPRequestResponse200FromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPRequestResponse200 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone_id': json['phone_id'],
    };
}

export function OTPRequestResponse200ToJSON(value?: OTPRequestResponse200 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone_id': value.phone_id,
    };
}

